import { requireClient } from './client'

let typingTimer: ReturnType<typeof setTimeout> | null = null
let lastRoomId: string | null = null

export function sendTyping(roomId: string) {
  const client = requireClient()

  if (lastRoomId && lastRoomId !== roomId) {
    client.sendTyping(lastRoomId, false, 0).catch(() => {})
  }

  lastRoomId = roomId
  client.sendTyping(roomId, true, 4000).catch(() => {})

  if (typingTimer) clearTimeout(typingTimer)
  typingTimer = setTimeout(() => {
    client.sendTyping(roomId, false, 0).catch(() => {})
    lastRoomId = null
  }, 4000)
}

export function stopTyping(roomId: string) {
  if (typingTimer) clearTimeout(typingTimer)
  typingTimer = null
  lastRoomId = null
  const client = requireClient()
  client.sendTyping(roomId, false, 0).catch(() => {})
}
